import CookieHelper from './cookieHelper';

export const DARK = 'dark';
export const LIGHT = 'light';
export const THEME_COOKIE = CookieHelper.CookieNameEnum.Theme;

// Pure decision core (no DOM). stored: 'dark'|'light'|null; systemPrefersDark: boolean.
export function pickTheme(stored, systemPrefersDark) {
  if (stored === DARK || stored === LIGHT) return stored;
  return systemPrefersDark ? DARK : LIGHT;
}

// 'dark' | 'light' | null (null = user has never chosen, still following the OS).
export function getStoredTheme() {
  const value = CookieHelper.getCookie(THEME_COOKIE, '');
  return value === DARK || value === LIGHT ? value : null;
}

export function getSystemPrefersDark() {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
}

export function resolveEffectiveTheme() {
  return pickTheme(getStoredTheme(), getSystemPrefersDark());
}

export function applyTheme(theme) {
  const el = document.documentElement;
  if (theme === DARK) el.setAttribute('data-theme', DARK);
  else el.removeAttribute('data-theme');
}

// Persist the explicit choice and apply it. Returns the theme set.
export function setTheme(theme) {
  const next = theme === DARK ? DARK : LIGHT;
  CookieHelper.setCookie(THEME_COOKIE, next);
  applyTheme(next);
  return next;
}

export function toggleTheme() {
  return setTheme(resolveEffectiveTheme() === DARK ? LIGHT : DARK);
}
